import { TextField } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import { actions } from '../../ReceivementOverviewListState'

export const InvoiceNumberFilterInput = () => {
  const dispatch = useDispatch()
  const invoiceNumber = useSelector((state) => state.receivementOverviewList.invoiceNumber)

  const setInvoiceNumber = (event: React.ChangeEvent<{ value: string }>) => {
    const { value } = event.target
    dispatch(actions.updateOverviewFilterField({ key: 'invoiceNumber', value }))
  }

  return (
    <TextField
      autoComplete='off'
      label='Nº da Nota'
      variant='outlined'
      size='small'
      onKeyPress={(e) => !/[0-9]|Enter/.test(e.key) && e.preventDefault()}
      fullWidth
      value={invoiceNumber}
      onChange={setInvoiceNumber}
      inputProps={{ 'data-testid': 'invoice-number-input' }}
    />
  )
}
